

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { StocksContext } from '../../context/stock/StockContext';
import { SuppliersContext } from '../../context/supplier/SupplierContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';
import { EXIT_KINDS } from './costing';


 

export const AvailableStockPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);    
    const { addStock, removeStock } = useContext(StocksContext);
    // Ingreso: ajuste de entrada al costo promedio (las compras van en Compras). Salida: tipo de salida y motivo
    const [exitType, setExitType] = useState(EXIT_KINDS[0].value);
    const [reference, setReference] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState(''); 
    const [units, setUnits] = useState([]);  

    var stock ;
    var add;

    if(state){
        stock = state.stock;
        add = state.add;
        stock.note = '';
    }
    
   
    const {formState, onInputChange } = useForm(stock);

   const { id, newStock, note } = formState

   useEffect(() =>{
     const formValid = parseFloat(newStock) > 0 && note.trim().length > 0
     setIsFormValid(formValid);
   }, [newStock, note])

 


 

    const handleSave = async ()=>{
        if (!isFormValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos.");
            return;
        }
        var resp = "";
        formState.id = id;
        if(add ) {        
            var available = {
                "id": id,
                "addStock": parseFloat(newStock),
                "reason": note.trim(),
                "note": note.trim()
            }
            resp = await addStock( available );
        } else {
            var remove = {
                "id": id,
                "removeStock": parseFloat(newStock),
                "exitType": exitType,
                "reference": exitType === 'DEVOLUCION_PROVEEDOR' ? reference.trim() : undefined,
                "reason": note.trim(),
                "note": note.trim()
            }
            resp = await removeStock(remove);
        }
        if(resp == "success"){
            setSuccessMessage("Inventario actualizado correctamente" );
        }else{
            setErrorMessage(resp);
        }
    }

    const removeError = ()=>{
        setErrorMessage('');
       }

       const removeSucessMessage = ()=>{
        setSuccessMessage('');
        navigate(-1);
       }

    return (
        
        <div className='container d-flex align-items-center justify-content-center mt-5' style={ styles.container }>
            

            <div className='col-md-6'>
            <h3>{ add ? 'Agregar a inventario' : 'Remover de inventario'}</h3> 
            <h5>{ stock.name }</h5> 
            <hr />

            <form className="row g-3 " >

           

           
           
                <div className="mb-3">
                    <label htmlFor="stockNameInput" className="form-label">Cantidad *</label>
                    <input 
                        id='stockNameInput'
                        type="number" 
                        className={`form-control${required.mark(!(parseFloat(newStock) > 0))}`}
                        placeholder="Cantidad"
                        name="newStock"
                        value={ newStock }
                        onChange={ onInputChange }
                        required
                    />
                    <div className="invalid-feedback">Campo requerido</div>
                </div>

                
                {!add && (
                    <div className="mb-3">
                        <label htmlFor="exitTypeSelect" className="form-label">Tipo de salida *</label>
                        <select id="exitTypeSelect" className="form-select" value={exitType} onChange={(e) => setExitType(e.target.value)}>
                            {EXIT_KINDS.map((k) => <option key={k.value} value={k.value}>{k.label}</option>)}
                        </select>
                    </div>
                )}
                {!add && exitType === 'DEVOLUCION_PROVEEDOR' && (
                    <div className="mb-3">
                        <label htmlFor="referenceInput" className="form-label">Factura del proveedor</label>
                        <input id="referenceInput" type="text" className="form-control" placeholder="Número de factura" maxLength={100}
                            value={reference} onChange={(e) => setReference(e.target.value)} />
                    </div>
                )}

                <div className="mb-3">
                    <label htmlFor="noteInput" className="form-label">Motivo *</label>
                    <input 
                        id='noteInput'
                        type="text" 
                        className={`form-control${required.mark(!note)}`}
                        placeholder="Nota"
                        name="note"
                        value={ note }
                        onChange={ onInputChange }
                        required
                    />
                    <div className="invalid-feedback">Campo requerido</div>
                </div>

                

                

               
                
                <div className='container d-flex align-items-center justify-content-center mt-5'>
                    <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                    <button type="button" onClick={handleSave} className="btn btn-primary ms-5">Guardar</button>
                </div>
                </form>
                <div style={{height: '100px'}}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            
            

        </div>
    )
}


const styles = {
    container: {
        flex:1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
